import { atom } from 'recoil';
import { PageType } from '../interfaces/Page';

export const selectedPageAtom = atom({
  key: 'selectedPage',
  default: PageType.STOCKS,
});
